import * as React from 'react';
import { pathOr } from 'ramda';

import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { CardsChoseQuestion } from '../../components/CardsQuestion';
import { useHandleSelect } from './utils/useHandleSelect';
import { QuestionLayoutContainer } from '../QuestionLayoutContainer';
import { useFormTracking } from '../../utils/useFormTracking';

export const CardsChoseQuestionContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const {
    question: { answers, answerField, iconType, title, required, helpText },
    answersState,
    setNextStep,
  } = props;

  const { trackSubmit } = useFormTracking();
  const handleSelect = useHandleSelect(props);

  if (!answers) {
    return null;
  }

  const value = pathOr([], [answerField, 'value'], answersState);

  const handleSubmit = () => {
    trackSubmit({
      isRequired: required,
      field: answerField,
      value: value.join(', '),
    });

    setNextStep(answersState);
  };

  const isNextBtnDisabled = required && !value.length;

  return (
    <QuestionLayoutContainer
      title={title}
      onSubmit={handleSubmit}
      description={helpText?.text}
      disableSubmit={isNextBtnDisabled}
    >
      <CardsChoseQuestion value={value} handleSelect={handleSelect} iconType={iconType} cards={answers} />
    </QuestionLayoutContainer>
  );
};

CardsChoseQuestionContainer.displayName = 'CardsChoseQuestionContainer';
